import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './App.tsx'
// i18next'i BURADA kuruyoruz. Modul govdesinde `init()` cagriliyor, yani
// ilk render'dan once katalog hazir oluyor. Bir bilesenin transitif
// import'una guvenmek yeterli olurdu ama kirilgan: `t` kullanan ilk bilesen
// bir gun lazy olursa ham anahtarlar bir an ekranda gorunurdu.
import './i18n'
import { watchBrowserConnectivity } from './lib/connection'
import { registerServiceWorker } from './lib/pwa'
import { applyResolvedTheme, readStoredTheme, resolveTheme } from './theme/theme'
import './index.css'
import './styles/theme-light.css'
// Ayarlar ve guvenlik ekranlarinin ORTAK panel iskeleti (bkz. panels.css
// basindaki not) - iki lazy chunk paylastigi icin global.
import './styles/panels.css'
import './auth.css'
import './chat.css'
import './attachments.css'
import './resilience.css'

// Tema, React MOUNT OLMADAN ONCE uygulaniyor: React ilk boyamadan SONRA
// calisir, bu satir olmadan acik tema kullanicilari her yuklemede bir
// karanlik "flash" gorur. Sayfada inline <script> YOK (CSP `script-src
// 'self'`, bkz. index.html) - bu yuzden cozum bir HTML script degil, bu
// modulun en tepesi: Vite onu hash'li bir dosyaya cevirip <head> disinda
// senkron calistiriyor, CSP'yi hic ihlal etmiyor.
applyResolvedTheme(resolveTheme(readStoredTheme()))

// Tarayici cevrimdisi olaylari - BIR KEZ, React'in disinda.
watchBrowserConnectivity()
registerServiceWorker()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
